
export const languageID = "manimDSL";

export const languageExtensionPoint = {
    id: languageID,
}
